import incentivesSearch from './incentivesSearchSlice';

const root = {
	incentivesSearch
};

export default root;
